import { useState } from 'react'
import { Input } from '../../components/Input'

import { ComponentsLayout } from './layout'

export const InputsPage = () => {
  const [textValue, setTextValue] = useState('')
  const [emailValue, setEmailValue] = useState('')
  const [passwordValue, setPasswordValue] = useState('')
  const [searchValue, setSearchValue] = useState('')

  return (
    <ComponentsLayout 
      title="Inputs" 
      description="Componentes de entrada de dados para formulários"
    >
      {/* Grid de exemplos */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        {/* Input Texto Padrão */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Input Texto</h3>
          <div className="space-y-4">
            <Input
              type="text"
              placeholder="Digite seu texto..."
              value={textValue}
              onChange={(e) => setTextValue(e.target.value)}
            />
            <Input
              type="text"
              placeholder="Input desabilitado"
              disabled
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Entrada de texto geral
          </div>
        </div>

        {/* Input Email */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Input Email</h3>
          <div className="space-y-4">
            <Input
              type="email"
              placeholder="seu@email.com"
              value={emailValue}
              onChange={(e) => setEmailValue(e.target.value)}
            />
            <Input
              type="email"
              placeholder="Email com erro"
              className="border-red-500 focus-visible:border-red-500 focus-visible:ring-red-500/20"
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Validação automática de email
          </div>
        </div>

        {/* Input Password */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Input Password</h3>
          <div className="space-y-4">
            <Input
              type="password"
              placeholder="Digite sua senha"
              value={passwordValue}
              onChange={(e) => setPasswordValue(e.target.value)}
            />
            <Input
              type="password"
              placeholder="Confirme sua senha"
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Campos de senha mascarados
          </div>
        </div>

        {/* Input Search */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Input Search</h3>
          <div className="space-y-4">
            <Input
              type="search"
              placeholder="Pesquisar..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Campos de busca com funcionalidades especiais
          </div>
        </div>

        {/* Input Number */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Input Number</h3>
          <div className="space-y-4">
            <Input
              type="number"
              placeholder="123"
              min="0"
              max="100"
            />
            <Input
              type="range"
              min="0"
              max="100"
              defaultValue="50"
              className="accent-blue-600"
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Entrada de valores numéricos
          </div>
        </div>

        {/* Input File */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Input File</h3>
          <div className="space-y-4">
            <Input
              type="file"
              accept="image/*"
            />
            <Input
              type="file"
              accept=".pdf,.doc,.docx"
              multiple
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Upload de arquivos
          </div>
        </div>

        {/* Input Date */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Input Date</h3>
          <div className="space-y-4">
            <Input
              type="date"
            />
            <Input
              type="datetime-local"
            />
            <Input
              type="time"
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Seleção de datas e horários
          </div>
        </div>

        {/* Input Variants */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Variações</h3>
          <div className="space-y-4">
            <Input
              type="text"
              placeholder="Input pequeno"
              className="h-8 text-xs"
            />
            <Input
              type="text"
              placeholder="Input padrão"
            />
            <Input
              type="text"
              placeholder="Input grande"
              className="h-12 text-base"
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Diferentes tamanhos via className
          </div>
        </div>

        {/* Estados de Validação */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Estados</h3>
          <div className="space-y-4">
            <Input
              type="text"
              placeholder="Estado normal"
            />
            <Input
              type="text"
              placeholder="Estado de sucesso"
              className="border-green-500 focus-visible:border-green-500 focus-visible:ring-green-500/20"
            />
            <Input
              type="text"
              placeholder="Estado de erro"
              className="border-red-500 focus-visible:border-red-500 focus-visible:ring-red-500/20"
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Diferentes estados visuais
          </div>
        </div>

      </div>

      {/* Seção de código */}
      <div className="mt-12 bg-white p-6 rounded-lg shadow-sm border">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Como usar</h3>
        <div className="bg-gray-50 p-4 rounded-md">
          <pre className="text-sm text-gray-800 overflow-x-auto">
{`import { Input } from '../../components/Input'

// Exemplo básico
<Input 
  type="text" 
  placeholder="Digite algo..." 
  value={value}
  onChange={(e) => setValue(e.target.value)}
/>

// Com validação
<Input 
  type="email" 
  placeholder="seu@email.com"
  className="border-red-500 focus-visible:border-red-500"
  required
/>

// File upload
<Input 
  type="file" 
  accept="image/*"
  multiple
/>`}
          </pre>
        </div>
      </div>
    </ComponentsLayout>
  )
}
